import { Typography, IconButton, Paper, Zoom, Fade, Box, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export default function ClarificationSlider(props) {

    const [textChunks, setTextChunks] = useState([]);

    const [currentChunk, setCurrentChunk] = useState(0);
    const [forwardButtonVisible, setForwardButtonVisible] = useState(true);
    const [slideToggler, setSildeToggler] = useState(true);
    
    useEffect(() => {
        setTextChunks(splitTextIntoChunks(props.text, 1));
        setCurrentChunk(0);
    }, [props.text])

    useEffect(() => {
        if (currentChunk >= textChunks.length-1) {
            setForwardButtonVisible(false);
        } else {
            setForwardButtonVisible(true);
        }
    }, [currentChunk, textChunks.length])

    const splitTextIntoChunks = (text, size) => {

        let strings = []
        let index = 0;
        let splittedString = text.split(". ");
        while (index < splittedString.length) {
            let chunk = []
            for (let i = index; i < size + index; i++) {
                chunk.push(splittedString[i]);
            }
            if (index !== splittedString.length-1) strings.push(chunk.join(". ") + ".");
            else {strings.push(chunk.join(". "))}
            index += size;
        }
        return strings;
    }

    const incrementChunk = () => {
        setSildeToggler(false);
        setTimeout(() => {
            setSildeToggler(true);
        }, 200)
        setCurrentChunk(currentChunk + 1);
    }

    return (
        <Zoom in={true} style={{ transitionDelay: 1000 }} >
            <Box sx={{
                display: "inline-flex",
                flexDirection: "column",
                alignItems: "center", 
                justifyContent: "center",
                marginTop: 2,
                width: "15rem"
            }}>
                {
                    forwardButtonVisible && 
                    <Button onClick={incrementChunk} color="primary" variant="text"
                        sx={{
                            display: "inline-flex",
                            '&:hover': {
                                cursor: "pointer"
                            },
                            mb: 1
                        }}
                    >
                        Weiterlesen
                    </Button>
                }
                <Fade direction="right" in={slideToggler} exit={false}>
                    <Paper sx={{
                        display: "inline-flex",
                        flexWrap: "wrap",
                        justifyContent: "end",
                        padding: 2
                    }}>
                        <Typography align="center"
                            sx={{width: "100%"}}
                        >
                            {textChunks[currentChunk]}
                        </Typography>
                    </Paper>
                </Fade>
            </Box>
        </Zoom>
    )
}